import React from 'react'
import { collection, query, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";
import { Box, Typography } from '@mui/material';
import IndustriesList from './IndustriesList';
export default function ReportsNavMenu() {

  const [sectors, setSectors] = React.useState([])
  const [loading, setLoading] = React.useState(true);

  // Get all the NAICS Sectors
  async function fetchSectors() {
    setLoading(true);
    const q = query(
      collection(db, "NAICS-Sectors"),
    );

    const allDocs = [];
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      const data = {
        ...doc.data(),
        "id": doc.id
      }
      allDocs.push(data);
    });

    setSectors(allDocs)
    setLoading(false)
  }

  React.useEffect(() => {
    fetchSectors();
  }, []);

  return loading ? <Box>
    <Typography variant='h4' align="center">Loading</Typography>
  </Box> : (
    <Box>
      {sectors.map((sector) => {
        return (
          <>
            <Typography variant='h4' align="center">{sector.name}</Typography>
            <IndustriesList sectorId={sector.id} />
          </>
        )
      })}
    </Box>
  )
}
